import { BookingStep } from '@ibe/models/ui';
import { BookingType } from '@ibe.models/booked-trip.model.lib';
import { DailyCost } from '@ibe.models/daily-cost.model';

/**
 * State for a BookedTrip
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	current_step: number;
	orig_booking_steps: BookingStep[];
	booking_steps: BookingStep[];
	booking_type: BookingType;
	costsPerDay: Array<DailyCost[]>;
	timeToThink: boolean;
	current_page: 'dates' | 'flights';
}

export const initialState: State = {
	loading: false,
	current_step: null,
	orig_booking_steps: [],
	booking_steps: [],
	booking_type: null,
	costsPerDay: null,
	timeToThink: false,
	current_page: null
};
